import { render } from "./AccGX.vue?vue&type=template&id=4469f334"
import script from "./AccGX.vue?vue&type=script&lang=js"
export * from "./AccGX.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__